module.exports = __webpack_public_path__ + "static/media/30OIOS12.c32a3105.jpg";